import { db } from 'utils';
import { getSelectedConvId } from 'selectors';

export const SET_SYSTEM_STATE = 'SYSTEM.SET_SYSTEM_STATE';

export const getSystemStatus = auth => (dispatch, getState) =>
  db.watch(`.info/connected`, is_online => {
    dispatch({ type: SET_SYSTEM_STATE, payload: { is_online } });
    if (is_online) {
      const conv_id = getSelectedConvId();
      conv_id && db.set(`convs/${conv_id}/info/watching/${auth.id}/${auth.session_id}`, true, null);
      db.set(`user_session/${auth.id}/${auth.session_id}/online`, true, db.time());
    }
  });

export const showOnline = isActive => (dispatch, getState) => {
  const conv_id = getSelectedConvId();
  const user = getState().user;
  if (isActive) {
    conv_id && db.set(`convs/${conv_id}/info/watching/${user.id}/${user.current_session}`, true, null);
    db.set(`user_session/${user.id}/${user.current_session}/online`, true, db.time());
  } else {
    conv_id && db.set(`convs/${conv_id}/info/watching/${user.id}/${user.current_session}`, null);
    db.set(`user_session/${user.id}/${user.current_session}/online`, db.time());
  }
};



// WEBPACK FOOTER //
// ./src/actions/system.js